export default {
 
  FieldsGet() {
    this.fields = {
      title: null,
      phone: null,
      telegram_chatid:null,
      user_register_date: null,
      user_last_payment: null,
      user_access: null,
      user_expire_date: null,
      user_tariff: null
    }
  },

  Fields() {
    this.fields = {
      salekey: null,
      salestate: 8,
      callState:null,
      notifytype: [],
      clienttype: null,
      comment: null
    }
    this.errors = {
      salekey: null,
      salestate: null,
      callState:null,
      notifytype: [],
      clienttype: null,
      comment: null
    }
  },

  validators: {
    salestate: ['req'],
    callState: ['req'],
  },

  labels: {
    name: 'ФИО',
    salestate: 'Статус заявки',
    callState: 'Статус звонка',
    notifytype: 'Тип уведомления',
    clienttype: 'Тип клиента',
    comment: 'Комментарий'
  },
  
  salestate: [
    {value: 4, text: 'открытая заявка'},
    {value: 8, text: 'заявка оформлена полностью'},
    {value: 16, text: 'заявка оформлена не до конца'},
    {value: 32, text: 'ожидает оплаты'}
  ],

  callstate: [
    {value: 4, text: 'успешный звонок'},
    {value: 8, text: 'перенос звонка'},
    {value: 16, text: 'недозвон'},
  ],

  notifytype: [
    {value: 1, text: 'SMS'},
    {value: 2, text: 'Telegram'},
    {value: 3, text: 'Whatsapp'},
    {value: 4, text: 'Viber'},
    {value: 5, text: 'Email'},
  ],

  clienttype: [
    {value: 1, text: 'частник'},
    {value: 2, text: 'перекуп'},
    {value: 3, text: 'организация'},
  ]

}
